import React, { FC, ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { BusinessDuoNeutralIcon } from '../neutral/BusinessDuoHighlighterNeutralIcon'
import { BusinessDuoHighlighterIcon } from '../BusinessDuoHighlighterIcon'
import { IntegrationType } from '../../../@types/config'
import { IV24rz45Icon } from '../iv24/IV24rz45Icon'
import { ReduxState } from '../../../store/reducers'

export const SellWithRealtorStepIcon: FC<ReactNode> = () => {
  const integrationType = useSelector((state: ReduxState) => state.config.integrationType)

  const renderActiveIcon = () => {
    switch (integrationType) {
      case IntegrationType.IMMOBILIENSCOUT24:
        return <BusinessDuoHighlighterIcon />
      case IntegrationType.IMMOVERKAUF24:
        return <IV24rz45Icon />
      case IntegrationType.EXTERNAL:
        return <BusinessDuoNeutralIcon />
    }
  }

  return <div className='icon-container'>{renderActiveIcon()}</div>
}
